module.exports = __webpack_public_path__ + "static/adam.3d5aea64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/people/adam.jpg
// module id = 346
// module chunks = 193747675109532